// extracted by mini-css-extract-plugin
export default {"cta":"SG-z","disabled":"TG-z"};